import { SpinResponse } from '@cgs/data-access';
import {
  AbstractGameConfig,
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameConfigProvider,
  IGameStateMachineProvider,
  ISlotGameEngineProvider,
  ReelsEngine,
  RegularSpinsSoundModel,
  RegularSpinsSoundModelComponent,
  T_IGameConfigProvider,
  T_ISlotGameEngineProvider,
  T_RegularSpinsSoundModelComponent,
} from '@cgs/machines';
import {
  Container,
  EmptyAction,
  FunctionAction,
  IntervalAction,
  SequenceAction,
  Vector2,
} from '@cgs/wge';

export class CorsicaAnticipationProvider {
  private gameConfig: AbstractGameConfig;
  private gameStateMachine: GameStateMachine<SpinResponse>;
  private regularSpinSoundModel: RegularSpinsSoundModel;
  private reelsEngine: ReelsEngine;

  private scatterCount: number = 0;
  private scatterSymbolId: number = 0;
  private scatterWinCount: number = 0;

  private lastReelBeforeAnticipation: number = 3;

  constructor(private readonly container: Container) {
    this.gameConfig = this.container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig;
    this.gameStateMachine = this.container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this.reelsEngine =
      this.container.resolve<ISlotGameEngineProvider>(T_ISlotGameEngineProvider).reelsEngine;

    this.scatterSymbolId = this.gameConfig.anticipationConfig.anticipationIcons[0];
    this.scatterWinCount = this.gameConfig.anticipationConfig.minIconsForWin;

    this.regularSpinSoundModel = container.resolve<RegularSpinsSoundModelComponent>(
      T_RegularSpinsSoundModelComponent
    ).regularSpinSoundModel;
  }

  public anticipationAction(reel: number): IntervalAction {
    if (this.gameStateMachine.curResponse.viewReels[reel].includes(this.scatterSymbolId)) {
      this.scatterCount++;
    }

    if (this.scatterCount < this.scatterWinCount - 1) {
      return new EmptyAction();
    }

    const actions: IntervalAction[] = [new EmptyAction()];

    if (reel === this.lastReelBeforeAnticipation) {
      const lastReel = reel + 1;
      const maxSpeedConfig = this.gameConfig.regularSpinConfig.spinSpeed * 3;
      const currentSpeed =
        this.gameConfig.regularSpinConfig.spinSpeed *
        this.gameConfig.regularSpinConfig.directions[lastReel];

      actions.push(
        new FunctionAction(() =>
          this.reelsEngine.accelerateReel(
            lastReel,
            new Vector2(0.0, currentSpeed),
            new Vector2(0.0, Math.max(maxSpeedConfig, currentSpeed)),
            0.3
          )
        )
      );

      actions.push(
        new FunctionAction(() => {
          this.regularSpinSoundModel.anticipatorSound(this.scatterSymbolId, 0).GoToState('start');
        })
      );
      actions.push(new EmptyAction().withDuration(1));
    }

    return new SequenceAction(actions);
  }

  public handleSlotStopped() {
    this.scatterCount = 0;
    this.regularSpinSoundModel.anticipatorSound(this.scatterSymbolId, 0).GoToState('default');
  }
}
